import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../../utils/auth';

export default function AuthLayout() {
  if (isAuthenticated()) {
    return <Navigate to="/entry_pages" replace />;
  }

  return (
    <div style={{ height: '100vh' }}>
      <Outlet />
    </div>
  );
}